import { Configuration as AuthApiConfiguration } from "./auth";

import { environment } from "@env/environment";

export function authApiConfigurationFactory(): AuthApiConfiguration {
  return new AuthApiConfiguration({
    basePath: environment.AUTH_API_BASE_URL,
    // Send/receive the HttpOnly refresh-token cookie on auth requests.
    withCredentials: true,
  });
}
